import * as ActionTypes from "./types";

export function fetchGettingStarted(isLoggedIn = false) {
  return {
    type: ActionTypes.FETCH_GETTING_STARTED,
    payload: { isLoggedIn },
  };
}

export function storeGettingStarted(payload) {
  return {
    type: ActionTypes.STORE_GETTING_STARTED,
    payload,
  };
}
